@if (actuality) {
    <article class="actuality-card__wrapper">
        <header class="actuality-card__header">
            <h3 class="actuality-card__title">
                {{ actuality.get('title') }}
            </h3>
        </header>
        <img class="actuality-card__image"
             [src]="actuality.get('image')?.url"
             alt="" />
        <div class="actuality-card__content"
             [innerHTML]="actuality.get('body')?.value">
        </div>
        <footer class="actuality-card__footer">
            @if (actuality.get('lien')) {
                <button class="actuality-card__see-more-button" (click)="action()">
                    @if (isActualityWithCollectivity) {
                        <span>{{ 'generic.read_article' | translate }}</span>
                    } @else {
                        <span>{{ 'generic.see_resource' | translate }}</span>
                    }
                    <mat-icon svgIcon="actuality-card__see-more"></mat-icon>
                </button>
            }
        </footer>
    </article>
}
